export { SplitImageFeatureSection as ScreenshotFeatureSection } from "../expanded-section-pack"